import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fileUrl = (url, download = false) => {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  if (!url.startsWith("/")) return url;
  const full = `${BACKEND_URL}${url}`;
  return download ? `${full}${full.includes("?") ? "&" : "?"}download=true` : full;
};

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tsf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const FOUNDATION = {
  name: "टूरिस्ट संदेश फाउंडेशन",
  nameEng: "Tourist Sandesh Foundation",
  logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_tourist-sandesh/artifacts/d7xw25e5_IMG-20260901-WA0034.jpg",
  email: "touristsandesh@gmail.com",
  phone: "+91 84779 37669",
  address: "गंगा दत्त जोशी मार्ग, कोटद्वार, पौड़ी गढ़वाल, उत्तराखंड",
  facebook: "https://www.facebook.com/sandeshlive",
  facebookName: "sandeshlive",
  instagram: "https://www.instagram.com/touristsandesh",
  instagramName: "touristsandesh",
  foundedYear: "2020",
  magazineYear: "2013",
  founder: "श्री सुभाष चंद्र नौटियाल",
};

export const NAV_ITEMS = [
  { label: "मुख्य पृष्ठ", path: "/" },
  { label: "हमारे बारे में", path: "/about" },
  { label: "टूरिस्ट संदेश मासिक", path: "/magazine" },
  { label: "लेख", path: "/articles" },
  { label: "पुस्तकालय", path: "/library" },
  { label: "शोध एवं प्रकाशन", path: "/research" },
  { label: "फोटो गैलरी", path: "/gallery" },
  { label: "हमारी पहल", path: "/initiatives" },
  { label: "संपर्क करें", path: "/contact" },
];

export const ARTICLE_CATEGORIES = ["पर्यटन", "संस्कृति", "विरासत", "यात्रा", "शोध", "उत्तराखंड", "भारत", "अन्य"];
export const GALLERY_CATEGORIES = ["फाउंडेशन गतिविधियाँ", "पर्यटन", "विरासत", "शोध", "कार्यक्रम", "क्षेत्र भ्रमण", "अन्य गतिविधियाँ"];
export const BOOK_CATEGORIES = ["संस्कृति", "पुरातत्व", "पर्यटन विकास", "ऐतिहासिक स्थल", "साहित्य", "अन्य"];
export const RESEARCH_CATEGORIES = ["शोध पत्र", "शोध लेख", "रिपोर्ट", "प्रकाशन", "महत्वपूर्ण दस्तावेज़"];

export default api;
